import { useAuthStore } from '../stores/authStore'
import { clearAuthToken, getAuthToken } from './authStorage'
import { isDevLocalShellSession } from './devLocalSession'

let redirecting = false

/** True when both persisted login flag and bearer token are present. */
export function hasValidSession(): boolean {
  const token = getAuthToken()
  const { isLoggedIn } = useAuthStore.getState()
  return Boolean(token && isLoggedIn)
}

/** Where to send the user after session expiry (homepage for students). */
export function getSessionExpiredRedirect(pathname: string): string {
  if (pathname.startsWith('/admin')) return '/admin/login'
  if (pathname.startsWith('/instructor-dashboard') || pathname.startsWith('/tutor/')) {
    return '/tutor'
  }
  if (pathname.startsWith('/school')) return '/school'
  return '/'
}

/**
 * Clear client auth state and hard-navigate so zustand cannot stay stale in memory.
 * Safe to call from axios interceptors (deduped).
 */
export function handleSessionExpired(pathname?: string): void {
  if (redirecting || typeof window === 'undefined') return
  // Keep DEV local shell open so /messages chrome can be inspected without a prod JWT.
  if (isDevLocalShellSession()) return
  redirecting = true

  try {
    useAuthStore.getState().logout()
  } catch {
    clearAuthToken()
    localStorage.removeItem('auth-storage')
    localStorage.removeItem('userRole')
  }

  const target = getSessionExpiredRedirect(pathname ?? window.location.pathname)
  window.location.assign(target)
}

export function shouldHandleUnauthorized(url: string): boolean {
  if (isDevLocalShellSession()) return false
  return (
    !url.includes('/profile-images/') &&
    !url.includes('/auth/login') &&
    !url.includes('/auth/refresh')
  )
}
